import React from "react";

const getText = (item, dataText) => {
    if(dataText.indexOf(", ") !== -1){
        const cadena = dataText.split(", ");
        return item[cadena[0]] + ", " + item[cadena[1]];
    }
    return item[dataText];
}

/**
 * @param {*} lista Un vector {label}
 * @returns 
 */
const ComboBox = ({ lista, dataText = "label", dataValue = "value", valorPorDefecto, onChange, className, ...resto }) => {
    return (
        <select onChange={onChange} className={"form-control form-control-sm " + className} {...resto}>
            {
                valorPorDefecto &&
                <option value={valorPorDefecto[dataValue]}>{valorPorDefecto[dataText]}</option>
            }
            {
                lista.map((item)=> <option key={item[dataValue]} value={item[dataValue]}>{getText(item, dataText)}</option>)
            }
        </select> 
    )
}

export default ComboBox;